<template>
    <div>
        <h3>Plan <router-link :to="'/admin/planView/' + ws.planId">{{ ws.planName }}</router-link></h3>
        <h1>Group</h1>
        <form id="search" @submit="updateGroup">
            <label for="name">{{ $t("admin.adminGroupView.name") }}: </label><input id="name" name="name" v-model="ws.name"><br/>
            <label for="description">{{ $t("admin.adminGroupView.description") }}: </label><textarea id="description" name="description" v-model="ws.description"></textarea><br/>
            <label for="enabled">{{ $t("admin.adminGroupView.enabled") }}: </label><input id="enabled" name="enabled" v-model="ws.enabled" type="checkbox"><br/>
            <label for="meterActive">{{ $t("admin.adminGroupView.meterActive") }}: </label><input id="meterActive" name="meterActive" v-model="ws.meterActive" type="checkbox"><br/>
            <div v-if="ws.meterCurrentlyActive">
                <label for="meter">{{ $t("admin.adminGroupView.meterValue") }}: </label><input id="meter" name="meter" v-model="meter.currentValue" type="text" readonly><br/>
            </div>

            <input type="submit" class="submit" v-bind:value="$t('admin.adminGroupView.button.update')">
        </form>
        <AdminGroupDelete v-bind:group="ws" />

        <hr/>
        <div v-if="ws.id">
            <h2>Projects</h2>
            <AdminProjectList :group-id="ws.id"></AdminProjectList>
        </div>

        <div v-if="meterModList">
            <hr/>
            <h2>{{ $t("admin.adminGroupView.meterModifications") }}</h2>
            <table class="datatable">
                <caption class="caption">Group meter list table</caption>
                <tr>
                    <th scope="col">{{ $t("admin.adminGroupView.table.timestamp") }}</th>
                    <th scope="col">{{ $t("admin.adminGroupView.table.user") }}</th>
                    <th scope="col">{{ $t("admin.adminGroupView.table.credits") }}</th>
                    <th scope="col">{{ $t("admin.adminGroupView.table.reason") }}</th>
                </tr>
                <tr v-for="(mm, index) in meterModList" v-bind:key="index">
                    <td>{{ new Date(mm.eventTimestamp).toLocaleString() }}</td>
                    <td><router-link :to="'/admin/userView/' + mm.userId">{{ mm.userName }}</router-link></td>
                    <td>{{ mm.modification }}</td>
                    <td>{{ mm.reason }}</td>
                </tr>
            </table>
        </div>

        <hr/>
        <h2>{{ $t("admin.adminGroupView.auditLog") }}</h2>
        <AdminAuditLogList :attrs="{'groupId': this.$route.params.groupId}"></AdminAuditLogList>
    </div>
</template>

<script>
    import { adminService } from '@/services/admin.service'
    import AdminAuditLogList from "./AdminAuditLogList";
    import AdminProjectList from "./AdminProjectList";
    import AdminGroupDelete from "./AdminGroupDelete";

    export default {
        name: 'AdminGroupView',
        components: {AdminProjectList, AdminGroupDelete, AdminAuditLogList},
        data: function() {
            return {
                ws: {},
                meter: {},
                meterModList: null
            };
        },
        created: function() {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                adminService.groupGet(this.$route.params.groupId).then((data) => {
                    this.ws = data;
                    if(data.description){
                        this.ws.description = decodeURIComponent(atob(data.description))
                    }
                    this.ws.meterCurrentlyActive = this.ws.meterActive;
                    if (this.ws.hasMeter) {
                        adminService.meterForGroup(this.$route.params.groupId).then((data) => {
                            this.meter = data;
                        });
                        adminService.meterModificationListForGroup(this.$route.params.groupId).then((data) => {
                            this.meterModList = data;
                        });
                    } else {
                        this.meterModList = null;
                    }
                }).catch((err) => {
                    console.error('Unable to get group: ', err)
                });
            },
            updateGroup: function(e) {
                e.preventDefault();
                let tmpGroupData = JSON.parse(JSON.stringify(this.ws))
                tmpGroupData.description = btoa(encodeURIComponent(this.ws.description))

                adminService.groupUpdate(this.$route.params.groupId, tmpGroupData).then(() => {
                    this.fetchData();
                }).catch((err) => {
                    console.error('Unable to update group: ', err)
                });
            }
        }
    }
</script>
